import Enum from '@/modules/core/app/models/abstracts/Enum';

export class RuleItemTypes extends Enum {
  static IDENTIFIER = 'identifier';

  static DELIMITER = 'delimiter';

  static SPECIAL = 'special';

  static CUSTOM_DELIMITER = 'custom_delimiter';
}

export const Delimiters = {
  SPACE: '(space)',
};

export const NamingConventionRoute = {
  NAMINGCONVENTIONS: 'namingconventions',
};

export const NamingConventionPathName = {
  NAMINGCONVENTIONS: 'namingconventions',
  NAMINGCONVENTIONFORM_NEW: 'namingconventionform:new',
  NAMINGCONVENTIONFORM: 'namingconventionform',
};
